import { useMissionContext } from '../../hooks/useMissionContext'
import { useAuth } from '@pilot-hub/auth'
import type { NavItem } from './ConditionalNavigation'

/**
 * Filtert Navigationseinträge nach Feature-Flag (show), Rolle, Einsatz, Funktion und Pilot-Modus.
 * Gemeinsame Logik von ConditionalNavigation und AppShell.
 */
export function useFilteredNavItems(items: NavItem[], pilotMode?: 'PILOT' | 'CO_PILOT'): { items: NavItem[]; hasMission: boolean } {
  const { activeMission, participantFunction } = useMissionContext()
  const { user } = useAuth()

  const effectivePilotMode = pilotMode || (localStorage.getItem('pilot-hub-pilot-mode') as 'PILOT' | 'CO_PILOT') || 'PILOT'
  const userRoles: string[] = (user?.rollen || []) as string[]

  const filtered = items.filter(item => {
    if (item.show === false) return false
    // Rollennamen case-insensitiv; Admin sieht alles, was eine Rolle verlangt
    if (item.roles && userRoles.length > 0) {
      const erlaubt = item.roles.map(r => r.toLowerCase())
      const userRolesLower = userRoles.map(r => String(r).toLowerCase())
      const istAdmin = userRolesLower.includes('admin')
      const hatErlaubteRolle = userRolesLower.some(r => erlaubt.includes(r))
      if (!hatErlaubteRolle && !istAdmin) return false
    }
    if (item.requiresMission && !activeMission) return false
    if (item.requiresFunction && participantFunction && !item.requiresFunction.includes(participantFunction)) return false
    if (item.pilotMode) {
      if (String(item.pilotMode).trim().toUpperCase() !== String(effectivePilotMode).trim().toUpperCase()) return false
    }
    return true
  })

  return { items: filtered, hasMission: !!activeMission }
}
